<template>
    <div>
        <app-component
            v-if="element.type == 'element' && element.object"
            :is="element.object.components.settings"
            :element="element"
            :locale="locale"
        />

        <app-form-element
            v-else-if="element.type == 'element'"
            :element="element"
            :locale="locale"
        />

        <app-form-section
            v-if="element.type == 'section'"
            :element="element"
            :locale="locale"
            :languages="languages"
        />

        <app-form-row
            v-if="element.type == 'row'"
            :element="element"
            :locale="locale"
        />

        <app-form-column
            v-if="element.type == 'column'"
            :element="element"
            :locale="locale"
        />

        <div class="composer-settings-toolbar">
            <div class="flex">
                <div class="flex-grow text-right" @click="close">
                    <a href="javascript:void(0)">
                        <app-icon icon="check" class="text-green" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .composer-settings-toolbar {
        position: fixed;
        bottom: 0;
        right: 0;
        left: auto;
        width: 25%;

        background: white;
        border-top: 1px solid #d3d3d3;
        z-index: 10;
    }

    .composer-settings-toolbar a {
        @apply .inline-block .p-4 .text-xl .text-grey-darkest;

        transition: all 0.2s ease-in-out;
    }

    .composer-settings-toolbar a:hover {
        @apply .bg-blue .text-white;
    }

    .composer-settings-toolbar a:hover i {
        @apply .text-white;
    }
</style>

<script>
import Section from './Forms/Section'
import Row from './Forms/Row'
import Column from './Forms/Column'
// import Element from './Forms/Element'

export default {
    components: {
        'app-form-section': Section,
        'app-form-row': Row,
        'app-form-column': Column,
        // 'app-form-element': Element
    },
    props: {
        element: {
            type: Object,
            required: true
        },
        languages: {
            type: Array,
            required: false
        },
        locale: {
            required: false
        }
    },

    data: () => ({
        loading: false
    }),

    methods: {
        close() {
            this.$emit('close')
        },
    },

    computed: {

    },
}
</script>



// WEBPACK FOOTER //
// src/components/composer/Settings.vue